import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useGovernmentProjectDetailDispatch } from "./government-project-detail-context";

export const useGovernmentProjectDetailController = () => {
    const GovernmentProjectDetailDispatch = useGovernmentProjectDetailDispatch();

    async function loadDetail(id: number) {
        try {
            GovernmentProjectDetailDispatch({
                type: ACTION_TYPES.setLoading,
                payload: true,
            });

            const result = await PortalAppService.requestGovernmentProjectDetail(id);

            GovernmentProjectDetailDispatch({
                type: ACTION_TYPES.setDetail,
                payload: result,
            });
        } catch (error) {
            console.error('Erro ao carregar detalhes do projeto:', error);
            GovernmentProjectDetailDispatch({
                type: ACTION_TYPES.setError,
                payload: 'Erro ao carregar os detalhes do projeto',
            });
        }
    }

    return {
        loadDetail
    };
}
